import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useReveal = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Defer slightly so newly mounted page elements are in the DOM
    const handle = setTimeout(() => {
      const els = document.querySelectorAll(".reveal");
      if (!("IntersectionObserver" in window)) {
        els.forEach((el) => el.classList.add("is-visible"));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
      );
      els.forEach((el) => {
        // Re-arm reveal on route change for elements without is-visible
        if (!el.classList.contains("is-visible")) io.observe(el);
      });
      // Cleanup observer when route changes
      return () => io.disconnect();
    }, 50);
    return () => clearTimeout(handle);
  }, [pathname]);
};
